import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Tech">
                <h1>Strategic & Tech Consulting Services</h1>
              </div>
              <p className="main_para">
                Paving your way to success through strategic and technology
                solutions
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                {" "}
                At TekRevol, we help our clients correct their course and
                execute strategies for them. Our tech consulting services
                encompass all the modern aspects and comprehensively cater to
                all the rising demands.
              </p>
              <ul>
                <li>Technology Value Deliverance</li>
                <li>Process Automation &amp; Improvement</li>
                <li>AI &amp; ML Modeling</li>
                <li>Mergers &amp; Acquisitions</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
